/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateTagDto = {
    /**
     * Tag name
     */
    name: string;
    /**
     * Tag description
     */
    description?: string;
    /**
     * Tag color in hex format (e.g., #ef4444)
     */
    color?: string;
    /**
     * Usage frequency counter
     */
    usageFrequency?: number;
    /**
     * Source of creation
     */
    source?: CreateTagDto.source;
};
export namespace CreateTagDto {
    /**
     * Source of creation
     */
    export enum source {
        CATALOG = 'CATALOG',
        SETTINGS = 'SETTINGS',
    }
}

